import { createContext, Dispatch } from "react";

export type UiPopupState = {
  selectedChatModel?: string; // "gpt-5-mini"
  selectedImageModel?: string; // "gpt-image-1"
  disableReferenceImage: boolean;
  customChatModel: string;
  customImageModel: string;
};

export type UiPopupAction =
  | Partial<UiPopupState>
  | ((state: UiPopupState) => UiPopupState);

export type UiPopupContextValue = {
  uiPopupContext: UiPopupState;
  uiPopupDispatch: Dispatch<UiPopupAction>;
};

const UIPopupContext = createContext<UiPopupContextValue | null>(null);

export const uiPopupContextReducer = (state = {}, action) => {
  if (typeof action === "function") {
    return action(state);
  }
  return {...state, ...action};
}

export default UIPopupContext;
